import { ReadOnlyField, SimpleGrid, Stack } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { CropPledgeSectionActions } from '../../shared/CropPledgeSectionActions';
import { useCropPledgeCreditorContext } from './context/CropPledgeCreditorContext';

export const PledgeCreditorPJForm = () => {
  const {
    selectedCreditorData,
    setCreditorInfo,
    isPendingSetCreditorInfo,
    approveSection,
    isPendingSectionApproval,
    creditorSectionStatus,
  } = useCropPledgeCreditorContext();

  const {
    fiscalId,
    igjIdentifier,
    streetName,
    streetNumber,
    province,
    locality,
    postalCode,
    email,
    phoneNumber,
    companyName,
  } = selectedCreditorData ?? {};
  const { t } = useTranslation();

  return (
    <Stack mt={6} gap={6}>
      <SimpleGrid columns={2} spacing={6}>
        <ReadOnlyField label={t('common.CUIT')} value={fiscalId ?? ''} />
        <ReadOnlyField
          label={t('common.companyName')}
          value={companyName || ''}
        />
        <ReadOnlyField label={t('common.IGJ')} value={igjIdentifier || ''} />
        <ReadOnlyField
          label={t('businessSignUp.form.addressStreet.label')}
          value={streetName || ''}
        />
        <ReadOnlyField
          label={t('businessSignUp.form.addressNumber.label')}
          value={streetNumber || ''}
        />
        <ReadOnlyField
          label={t('businessSignUp.form.state.label')}
          value={province || ''}
        />
        <ReadOnlyField
          label={t('businessSignUp.form.locality.label')}
          value={locality || ''}
        />
        <ReadOnlyField
          label={t('businessSignUp.form.zipCode.label')}
          value={postalCode || ''}
        />
        <ReadOnlyField label={t('common.email')} value={email || ''} />
        <ReadOnlyField label={t('common.phone')} value={phoneNumber || ''} />
      </SimpleGrid>
      <CropPledgeSectionActions
        sectionStatus={creditorSectionStatus!.status}
        onRequestApproval={() => setCreditorInfo({ fiscalId: fiscalId ?? '' })}
        isPendingRequestApproval={isPendingSetCreditorInfo}
        onApprove={() => approveSection({})}
        isPendingApprove={isPendingSectionApproval}
      />
    </Stack>
  );
};
